import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangePurchaseNetPriceExchangeDateCommand extends BaseCommand {
  CommandName = "ChangePurchaseNetPriceExchangeDate";
  Command: {
    Date: string;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, date: string) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Date: date };
  }
}
